import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import './homebanner.css'

// Example approach: Define arrays to hold image info
// so you can map them instead of manually listing <img> tags.
const firstRowImages = [
  { id: 1, alt: 'Industrial Machinery Manufacturer', src: 'https://images.pexels.com/photos/2760241/pexels-photo-2760241.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1' },
  { id: 2, alt: 'Cutting Operations', src: 'https://images.pexels.com/photos/1145434/pexels-photo-1145434.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1' },
  { id: 3, alt: 'Grinding Operations', src: 'https://images.pexels.com/photos/162534/grinder-hitachi-power-tool-flexible-162534.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1' },
  { id: 4, alt: 'Welding', src: 'https://images.pexels.com/photos/3158651/pexels-photo-3158651.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1' },
  { id: 5, alt: 'Machining', src: 'https://images.pexels.com/photos/7480242/pexels-photo-7480242.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1' },
  { id: 6, alt: 'Cutting Machine', src: 'https://images.pexels.com/photos/9242202/pexels-photo-9242202.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1' },
]

const secondRowImages = [
  { id: 1, alt: 'Valve Cladding', src: 'https://i.postimg.cc/FsjthL9q/valve-cladding-1.png' },
  { id: 2, alt: 'Positioner', src: 'https://i.postimg.cc/V6f8LW7k/positioner-1.jpg' },
  { id: 3, alt: 'Pipe Cladding', src: 'https://i.postimg.cc/Zn7RP8Fj/pipe-cladding-ext-1-png.jpg' },
  { id: 4, alt: 'Pipe Welding', src: 'https://i.postimg.cc/J0fqqmdq/orbital-welder-1.jpg' },
  { id: 5, alt: 'Welding Rotators', src: 'https://i.postimg.cc/0NF9ZwZN/welding-rotator-1.png' },
  { id: 6, alt: 'Cutting Machine', src: 'https://images.pexels.com/photos/9242202/pexels-photo-9242202.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1' },
]

// Note: Adjust the arrays as needed or dynamically pass them in via props.

const HomeBanner = ({
  heading1 = 'We measure our success with yours!',
  content1 = `We specialize in designing and manufacturing high-quality industrial machinery for various industries. Our cutting-edge technology and expertise ensure top-notch performance and reliability.`,
  action1 = 'Explore Our Products',
  action2 = 'Request a FREE consultation',
  image1Src,
  // ...the rest of your image props, if actually needed
}) => {
  return (
    <div className="homebanner-header78">
      {/* TEXT + BUTTONS SECTION */}
      <div className="homebanner-column thq-section-max-width thq-section-padding">
        <div className="homebanner-content1">
          <h1 className="thq-heading-1">{heading1}</h1>
          <p className="thq-body-large">{content1}</p>
        </div>

        <div className="homebanner-actions">
          {/* Button + Link #1 */}
          <Link
            to="/products"
            className="homebanner-button1"
          >
            <span>{action1}</span>
          </Link>

          {/* Button + Link #2 */}
          <Link
            to="/contact-us"
            className="homebanner-button2"
          >
            <span>{action2}</span>
          </Link>
        </div>

      </div>

      {/* SCROLLING IMAGES SECTION */}
      <div className="homebanner-content2">
        <div className="homebanner-row-container1 thq-mask-image-horizontal thq-animated-group-container-horizontal">
          <div className="thq-animated-group-horizontal">
            {firstRowImages.map((img) => (
              <img
                key={img.id}
                alt={img.alt}
                src={img.src}
                className="homebanner-placeholder-image thq-img-scale thq-img-ratio-1-1"
              />
            ))}
          </div>
          <div className="thq-animated-group-horizontal">
            {firstRowImages.map((img) => (
              <img
                key={img.id}
                alt={img.alt}
                src={img.src}
                className="homebanner-placeholder-image thq-img-scale thq-img-ratio-1-1"
              />
            ))}
          </div>
        </div>

        <div className="homebanner-row-container2 thq-mask-image-horizontal thq-animated-group-container-horizontal">
          <div className="thq-animated-group-horizontal-reverse">
            {secondRowImages.map((img) => (
              <img
                key={img.id}
                alt={img.alt}
                src={img.src}
                className="homebanner-placeholder-image thq-img-scale thq-img-ratio-1-1"
              />
            ))}
          </div>
          <div className="thq-animated-group-horizontal-reverse">
            {secondRowImages.map((img) => (
              <img
                key={img.id}
                alt={img.alt}
                src={img.src}
                className="homebanner-placeholder-image thq-img-scale thq-img-ratio-1-1"
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

HomeBanner.propTypes = {
  heading1: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  content1: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  action1: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  action2: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  image1Src: PropTypes.string, // add the rest only if needed
}

export default HomeBanner
